import React from 'react';
import { BenefitsItem } from '../types';

type BenefitsProps = {
    items: Array<BenefitsItem>;
};

export const BenefitsList: React.FC<BenefitsProps> = (props) => {
    const renderItems = () => {
        return props.items.map(({ heading, info }) => (
            <div
                key={heading.toString()}
                className="boost-benefits__benefits--item"
            >
                <h5 className="eds-text-bm eds-text-weight--heavy">
                    {heading}
                </h5>
                <span className="eds-text-bm">{info}</span>
            </div>
        ));
    };
    return <div className="boost-benefits__benefits">{renderItems()}</div>;
};
